<template>
  <div>
    <div class="app-list">
      <template v-if="!isPending && data.length && !isFailed">
        <a-table
          :columns="columns"
          :row-key="getRowKey"
          :expand-row-by-click="true"
          :pagination="false"
          :data-source="data">
          <span
            slot="id"
            slot-scope="text">
            <a
              target="_blank"
              :href="`/verification/${text}`"
              @click="e => toVerification(e, text)">
              {{ text }}
              <i class="mdi mdi-open-in-new" />
            </a>
          </span>

          <span
            slot="userId"
            slot-scope="text">
            <copyable :copy-text="text.toString()">{{ text }}</copyable>
          </span>

          <p
            slot="expandedRowRender"
            slot-scope="record"
            style="margin: 0">
            <verification-comment-form
              :verification="record"
            />
          </p>
        </a-table>
      </template>
      <template v-else>
        <div class="app-list__li-like">
          <template v-if="!data.length">
            <p>
              {{ "user-verifications.nothing-here-yet" | globalize }}
            </p>
          </template>

          <template v-else-if="isFailed">
            <p>
              {{ "user-verifications.default-error-message" | globalize }}
            </p>
          </template>

          <template v-else>
            <p>
              {{ "user-verifications.loading-message" | globalize }}
            </p>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import { api } from '@/api'
import { vueRoutes } from '@/vue-router/routes'
import { clearObject } from '@/js/helpers/clear-object'
import { ErrorHandler } from '@/js/helpers/error-handler'
import { VerificationRecord } from '@/js/records/entities/verification.record'
import ATable from 'ant-design-vue/lib/table'
import Copyable from '@/vue/common/copyable/Copyable'
import VerificationCommentsForm from '@/vue/forms/VerificationCommentForm'

const columns = [
  {
    title: 'Verification ID',
    dataIndex: 'id',
    key: 'id',
    scopedSlots: {
      customRender: 'id',
    },
  },
  {
    title: 'User ID',
    dataIndex: 'userId',
    key: 'userId',
    scopedSlots: {
      customRender: 'userId',
    },
  },
  {
    title: 'Status', dataIndex: 'status', key: 'status',
  },
  { title: 'Type', dataIndex: 'type', key: 'type' },
  {
    title: 'Comments',
    dataIndex: 'comments',
    key: 'comments',
    customRender: (str, record) => {
      return record.comments.length
    },
  },
]

export default {
  name: vueRoutes.userVerificationComments.name,
  components: {
    'a-table': ATable,
    'verification-comment-form': VerificationCommentsForm,
    'copyable': Copyable,
  },
  data () {
    return {
      isFailed: false,
      isPending: false,
      data: [],
      columns,
    }
  },
  async created () {
    await this.getVerifications()
  },
  methods: {
    async getVerifications () {
      this.isPending = true
      this.isFailed = false

      try {
        const query = {
          filter: clearObject({
            user_id: this.$attrs.id,
          }),
        }

        const { data } = await api.getWithSignature('/verifications', query)

        this.data = data
          .filter(rec => rec.comments && rec.comments.length > 0)
          .map(i => new VerificationRecord(i))
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
        this.isFailed = true
      } finally {
        this.isPending = false
      }
    },
    getRowKey (record) {
      return `verification-${record.id}`
    },
    toVerification (ev) {
      ev.stopPropagation()
    },
  },
}
</script>

<style scoped>
  @import '~ant-design-vue/lib/table/style/index.css';

</style>
